export default "__VITE_ASSET__CeVrLGvK__"